<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <span>显示禁用账户</span
      ><el-checkbox
        v-model="query.isProhibit"
        size="small"
        style="margin-right: 10px"
      />
      <el-input
        v-model="query.userNumber"
        placeholder="账户"
        size="small"
        style="width: 200px"
      />
      <el-input
        v-model="query.fName"
        placeholder="经销商"
        size="small"
        style="width: 200px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="userNumber" label="账户" />
        <el-table-column prop="fName" label="经销商" min-width="300" />
        <el-table-column prop="fCorperate" label="负责人" />
        <el-table-column prop="fBalance" label="账户余额" />
        <el-table-column label="操作" class-name="table-oper-col" width="200">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >查看</el-button
              >
              <el-button
                v-if="canBalance"
                type="text"
                size="small"
                @click="_adjust(scope.row)"
                >余额调整</el-button
              >
              <el-button
                v-if="canEditPW"
                type="text"
                size="small"
                @click="_modifyPW(scope.row)"
                >修改密码</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EditForm from "./EditForm";
import EditPW from "./EditPW";
import EditBalance from "./EditBalance";

export default {
  components: {
    EditForm,
    EditPW,
    EditBalance,
  },
  data() {
    return {
      query: {
        userNumber: null,
        fName: null,
        isProhibit: false,

        pageIndex: 1,
        pageSize: 20,
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canEdit: true,
      canEditPW: true,
      canBalance: true,
    };
  },
  mounted() {
    this.refresh();

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == "004008002") {
        this.canEdit = val.isGrant;
      }
      if (val.key == "004008003") {
        this.canEditPW = val.isGrant;
      }
      if (val.key == "004008004") {
        this.canBalance = val.isGrant;
      }
    });
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$httpPost(
        "BasicInformation/Distributor/DistributorBalanceEntry",
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist.dataEntry;
          this.pageRecordTotal = res.datalist.total;
        })
        .finally(() => (this.loading = false));
    },
    _modify: async function (row) {
      this.currentEditItem = await this.$httpPost(
        "BasicInformation/Distributor/DistributorrBalance",
        { fid: row.fDistributorID }
      ).then((res) => res.datalist);

      const h = this.$createElement;
      this.$formDlg({
        title: "账户信息",
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(formData),
        width: "30%",
        readonly: !this.canEdit,
      });
    },
    _modifyPW: function (row) {
      this.currentEditItem = {
        id: row.fDistributorID,
        name: row.userNumber,
        pw: null,
      };
      const h = this.$createElement;
      this.$formDlg({
        title: "修改密码",
        formTpl: <EditPW form={this.currentEditItem}></EditPW>,
        formSubmit: (formData) => this.changePW(formData),
        width: "30%",
        readonly: !this.canEditPW,
      });
    },
    _adjust: function (row) {
      // console.log(row, 'row')
      row.modifyType = "充值";
      row.fMoney = 0;
      this.currentEditItem = Object.assign({}, row);
      const h = this.$createElement;
      this.$formDlg({
        title: "余额调整",
        formTpl: <EditBalance form={this.currentEditItem}></EditBalance>,
        formSubmit: (formData) => this.postBalance(formData),
        width: "30%",
        readonly: !this.canBalance,
      });
    },
    postData(info) {
      return this.$httpPost(
        `BasicInformation/Distributor/DistributorrBalanceModify`,
        {
          datalist: JSON.stringify(info),
        }
      ).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    changePW: function (data) {
      return this.$httpPost("BasicInformation/Distributor/PasswordChange", {
        fid: data.id,
        newPassword: data.pw,
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    postBalance(info) {
      // console.log(info, 'for')
      return this.$httpPost(`BasicInformation/Distributor/BalanceModify`, {
        datalist: JSON.stringify(info),
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    getUserName: function () {
      return this.$httpPost(
        "BasicInformation/Distributor/MaxDistributorNu"
      ).then((res) => res.datalist);
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
